import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-userCenter5",
  "use": "icon-userCenter5-usage",
  "viewBox": "0 0 44 44",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 44\" id=\"icon-userCenter5\"><g fill=\"none\" fill-rule=\"nonzero\"><path fill=\"#062337\" d=\"M1.254 29.19v3.383l21.19 10.856 21.19-10.856V29.19l-21.19 10.868z\" /><path fill=\"#062337\" d=\"M.99 18.488v3.383l21.19 10.856 21.19-10.856v-3.383L22.18 29.357z\" /><path d=\"M3.615 11L22 20.1 40.385 11 22 1.9 3.615 11zm7.071 0L22 5.4 33.314 11 22 16.6 10.686 11z\" fill=\"#2F54EB\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol